
import {map,  tap } from 'rxjs/operators';
/**
 *****************************************
 *                                       *
 * NAGARRO  - CSX - CONFIDENTIAL         *
 *                                       *
 *****************************************
 */


import { AppUtilityService } from "../../../core/services/app-utility.service";
import { BehaviorSubject ,  Observable } from "rxjs";
import { ConfigService } from "../../../core/services/config.service";
import { DataStoreService } from "../../../core/services/datastore.service";
import { HttpStatus } from "../../../core/model/http-status-enum.model";
import { Injectable } from "@angular/core";
import { LmsLoaderService } from "./../../../core/services/lms-loader.service";
import { LmsLoggerService } from "../../../core/services/lms-logger.service";
import { LmsTerminalStatusSubmenuService } from "./../../../core/services/lms-terminal-status-submenu.service";
import { MessageDetails } from "../../../core/model/message-details.model";
import { MessageHandlerService } from "../../../core/services/message-handler.service";
import { Router } from "@angular/router";
import { StaticDataStoreService } from "./../../../core/services/static-datastore.service";
import { Tab } from "../../../core/model/tab.model";
import { TabData } from "../../../core/model/tab-data.model";
import { TerminalHandling } from "../model/terminal-handling.model";
import { TerminalHandlingExcel } from "./../model/terminal-handling-excel.model";
import { TerminalHandlingUpdateRequest } from "./../../../core/model/terminal-handling-update-request-model";
import { HttpClient, HttpHeaders } from "@angular/common/http";

/**
 * @export
 * @class TerminalHandlingService
 */
@Injectable()
export class TerminalHandlingService {
  private RESOURCE_URL = "/terminals/";
  private RESOURCE_THP_URL = "/thp";
  private configData: any;

  loadData: Observable<TerminalHandling>;
  private loadDataBS: BehaviorSubject<TerminalHandling>;

  terminalHandlingBS: BehaviorSubject<Object>;
  terminalHandling: Observable<Object>;

  /**
   * Creates an instance of TerminalHandlingService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {DataStoreService} dataStoreService
   * @param {LmsLoggerService} lmsLoggerService
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {LmsTerminalStatusSubmenuService} lmsTerminalStatusSubmenuService
   * @param {Router} router
   * @param {LmsLoaderService} lmsLoaderService
   * @memberOf TerminalHandlingService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private staticDataStoreService: StaticDataStoreService,
    private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService,
    private appUtilityService: AppUtilityService
  ) {
    this.configData = this.configService.getConfigData();

    this.loadDataBS = <BehaviorSubject<TerminalHandling>>(
      new BehaviorSubject({})
    );
    this.loadData = this.loadDataBS.asObservable();
  }

  /**
   * For reset all events.
   * @memberOf TerminalHandlingService
   */
  resetAll() {
    // will set things as per out need but right now its need to be defined
  }

  /**
   * This loads data of Terminal Handling Page
   * @param {Tab} tab
   * @memberOf TerminalHandlingService
   */
  load(tab: Tab, fromOtherOperation?: boolean, messageText?: string) {
    let terminalHandling: TerminalHandling;
    let foundInDataStore = false;
    setTimeout(() => {
      if (document.getElementById("autoCompleteTexttopHeader")) {
        const selectBox = <HTMLInputElement>(
          document.getElementById("autoCompleteTexttopHeader")
        );
        if (selectBox) {
          selectBox.select();
        }
      }
    }, 50);
    if (tab && tab.tabSearchParameter) {
      if (tab.tabSearchParameter.searchText) {
        tab.tabSearchParameter.searchText =
          tab.tabSearchParameter.searchText.trim();
      } else {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if ("error" === tab.subTypeDetail[tab.subType.toLowerCase()].status) {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== "refresh") {
        const tabData = this.dataStoreService.getValue(tab);
        if (tabData) {
          this.lmsLoaderService.showLoader();
          terminalHandling = <TerminalHandling>tabData.data[tab.subType];
          foundInDataStore = true;
          this.loadDataBS.next(terminalHandling);
          this.lmsLoaderService.hideLoader();
        }
      } else {
        foundInDataStore = false;
      }
      if (!foundInDataStore) {
        if (!this.isMnemonicExist(tab.tabSearchParameter.searchText)) {
          const lTerminalHandling = <TerminalHandling>{
            httpStatus: 400,
            errorMessage:
              this.configService.getConfigData().messages.invalidTerminal,
          };
          this.loadDataBS.next(lTerminalHandling);
          this.lmsLoaderService.hideLoader();
          this.lmsLoggerService.logError(
            "TerminalHandlingService => load()",
            this.configService.getConfigData().messages.invalidTerminal
          );
        } else {
          const opr = "INQU";
          this.lmsLoaderService.showLoader();
          const apiUrl = this.configData.urls.API_URL;
          this.lmsLoggerService.logInfo(
            "TerminalHandlingService=>load service call starts"
          );
          this.http
            .get(
              `${apiUrl}${this.RESOURCE_URL}${tab.tabSearchParameter.searchText}${this.RESOURCE_THP_URL}?opr=${opr}`
            )
            .pipe(
              tap(() =>
                this.lmsLoggerService.logInfo(
                  "TerminalHandlingService=>load service call ends"
                )
              )
            )
            .subscribe(
              (data: any) => {
                if (data && data.priorityCode) {
                  const pCode = parseInt(data.priorityCode, 10);
                  if (pCode >= 1 && pCode <= 4) {
                    const lTerminalHandling = <TerminalHandling>{
                      locoInfoList: data.locoInfoList,
                    };
                    lTerminalHandling.refreshTime = data.refreshTime;
                    lTerminalHandling.tabId = tab.id;
                    const tabData = <TabData>{
                      id: tab.id,
                      subType: tab.subType,
                    };
                    tabData.data = tabData.data ? tabData.data : {};
                    tabData.data[tab.subType] = lTerminalHandling;
                    tab.subTypeDetail.handling.message = "";
                    lTerminalHandling.errorMessage = "";
                    this.lmsLoaderService.hideLoader();
                    lTerminalHandling.httpStatus = HttpStatus.OK;
                    this.dataStoreService.putValue(tab, tabData);
                    this.loadDataBS.next(lTerminalHandling);
                    this.lmsLoggerService.logInfo(
                      "TerminalHandlingService => load()",
                      `Terminal Handling Data Fetch Successfull for ${JSON.stringify(
                        tab
                      )}`
                    );

                    if (fromOtherOperation) {
                      this.messageHandlerService.handleMessage(<MessageDetails>{
                        type: this.configData.message.type.client,
                        level: this.configData.message.level.success,
                        target: this.configData.message.target.page,
                        message: messageText,
                      });
                    }
                  } else {
                    this.lmsLoaderService.hideLoader();
                    const lTerminalHandling = <TerminalHandling>{
                      httpStatus: 400,
                      errorMessage: fromOtherOperation
                        ? messageText + ", but " + data.messageText
                        : data.messageText,
                    };
                    this.loadDataBS.next(lTerminalHandling);
                    this.lmsLoggerService.logError(
                      "TerminalHandlingService => load()",
                      data.messageText
                    );
                  }
                }
              },
              (error) => {
                this.lmsLoaderService.hideLoader();
                const lTerminalHandling = <TerminalHandling>{
                  httpStatus: error.status,
                  errorMessage: fromOtherOperation
                    ? messageText +
                      ", but an error has occurred while refreshing the page."
                    : this.appUtilityService.getHttpErroMessage(error, false),
                };
                this.loadDataBS.next(lTerminalHandling);
                this.lmsLoggerService.logError(
                  "TerminalHandlingService => load()",
                  this.appUtilityService.getHttpErroMessage(error, false)
                );
              }
            );
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.loadDataBS.next(null);
    }
  }

  /**
   * This is used to clean the tab Data
   * @param {Tab} tab
   * @memberOf TerminalHandlingService
   */
  clean(tab: Tab) {
    this.dataStoreService.removeSubPanel(tab);
  }

  /**
   * Check for menmonic exist in static datastore.
   *
   * @param {string} value
   * @returns {boolean}
   *
   * @memberOf TerminalHandlingService
   */
  isMnemonicExist(value: string): boolean {
    if (
      value === "DELETE" ||
      value === "OFFLN" ||
      value === "NEW" ||
      value === "PARKED"
    ) {
      return true;
    }
    if (this.staticDataStoreService.getValue("commonopsPicklist")) {
      const commonopsPicklist =
        this.staticDataStoreService.getValue("commonopsPicklist");
      if (commonopsPicklist) {
        const data = commonopsPicklist.mapOfMnemonis
          ? commonopsPicklist.mapOfMnemonis
          : null;
        for (const key in data) {
          if (
            value &&
            data.hasOwnProperty(key) &&
            value.trim().toUpperCase() === data[key].trim().toUpperCase()
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * Right pad for locomotive id.
   * @private
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   * @memberOf TerminalHandlingService
   */
  private rightPad(str, padString, max): string {
    str = str.toString();
    return str.length < max
      ? this.rightPad(str + padString, padString, max)
      : str;
  }

  /**
   * @memberOf TerminalHandlingService
   */
  cleanBehaviourSubject() {
    this.loadDataBS.next(null);
  }

  /**
   * Update terminal handling plan.
   * @param {Tab} tab
   * @param {TerminalHandlingUpdateRequest} terminalHandlingUpdateRequest
   * @returns {Observable<Response>}
   *
   * @memberOf TerminalHandlingService
   */
  updateThp(
    tab: Tab,
    terminalHandlingUpdateRequest: TerminalHandlingUpdateRequest
  ): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    const opr = "UTHP";
    const wc = "LWTW";
    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TerminalHandlingService=>updateThp service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}${this.RESOURCE_URL}${tab.tabSearchParameter.searchText}/locomotives/thp?opr=${opr}&wc=${wc}`,
        JSON.stringify(terminalHandlingUpdateRequest),
        options
      )
      .pipe(
        tap(() => {
          this.lmsLoggerService.logInfo(
            "TerminalHandlingService=>updateThp service call ends"
          );
          this.lmsLoggerService.logInfo(
            "terminalHandlingService => updateThp()",
            `Terminal Hanlding Plan Updated for ${JSON.stringify(
              terminalHandlingUpdateRequest
            )}`
          );
        })
      );
  }

  /**
   * Download Excel
   * @param {TerminalHandlingExcel} terminalHandlingExcel
   * @returns {Observable<any>}
   * @memberof TerminalHandlingService
   */
  excelDownload(terminalHandlingExcel: TerminalHandlingExcel): Observable<any> {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append("Content-Type", "application/json");
    return this.http
      .post(
        `${apiUrl}${this.RESOURCE_URL}thp/excel`,
        JSON.stringify(terminalHandlingExcel),
        { headers: headers, responseType: "blob" }
      ).pipe(
      map((res) => new Blob([res], { type: "application/vnd.ms-excel" })));
  }
}
